import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeDealCreate,
  detail: routeDealDetail,
  home: routeDealsHome,
  root: routeDealsRoot,
} = createDoctypeRoutes({
  createName: 'new-deal',
  createPath: 'new-deal',
  detailName: 'dealDetail',
  doctype: DOCTYPES.OPPORTUNITY,
  homeName: 'deals-home',
  path: 'deals',
  views: {
    create: async () => await import('@/components/viewsExternal/deals/AddDeal.vue'),
    detail: async () => await import('@/components/viewsExternal/deals/ViewDeal.vue'),
    list: async () => await import('@/components/viewsExternal/deals/DealView.vue'),
  },
})

export { routeDealCreate, routeDealDetail, routeDealsHome, routeDealsRoot }
